import _ListPage from './ListPage'

export const ListPage = _ListPage
